import React from 'react';
import FinancialDashboard from '../dashboard/FinancialDashboard';

const FinancialAnalysisPage = () => {
  return (
    <div className="financial-analysis-page">
      <FinancialDashboard />
    </div>
  );
};

export default FinancialAnalysisPage;